const DEFAULT_TASK_QUANTITY = 1;
const GST = 10 / 100

module.exports = {
  DEFAULT_TASK_QUANTITY,
  GST
};
